export const InitialRoute = "/";
export const HomeRoute = "/home";
export const LoginRoute = "/login";
export const CreateAccountRoute = "/create-account";
export const DashboardRoute = "/dashboard";
export const OtpRoute = "/otp";
export const ContactUsRoute = "/contact-us";
export const SubmitFeedbackRoute = "/submit-feedback";
export const PrivacyPolicyRoute = "/privacy-policy";
export const ForgotPasswordRoute = "/forgot-password";
export const ResetPasswordRoute = "/reset-password";
export const InitRoute = "/init";
export const SignUpRoute = "/sign-up";
export const StartExperienceRoute = "/start-experience";
export const VideoChatRoute = "/video-chat";
export const TermsOfServiceRoute = "/terms-of-service";
export const ModelProfileRoute = "/avatar-profile/:name";
export const EveProfileRoute = "/eve";
export const PaymentRoute = "/payment";
export const PageNotFound = "/page-not-found";
export const Statement2257Route = "/2257-statement";
export const ComplaintsPolicyRoute = "/complaints-policy";
export const ContentRemovalPolicyRoute = "/content-removal-policy";
